import { Deposit, AnnotatorVerdict, AnnotatorDeposit, PaginatedAnnotatorDeposits } from 'types/api.types';
import { apiService } from './apiService';

export const reviewDeposit = async (id: number, verdict: AnnotatorVerdict) => {
  try {
    return await apiService.post<Deposit>(`/deposits/review/${id}`, verdict);
  } catch (error) {
    return null;
  }
};

export const getDepositsForReview = async (
  page = 1,
  limit = 10,
): Promise<PaginatedAnnotatorDeposits | null> => {
  try {
    return await apiService.get<PaginatedAnnotatorDeposits>(
      `/deposits/approvals?page=${page}&limit=${limit}`,
    );
  } catch (error) {
    return null;
  }
};
